import { env } from '@src/config/env';

let warnedEmptyProdAllowlist = false;

/**
 * Returns true when `origin` is permitted to send postMessage events to the
 * terminal.
 *
 * The allowlist is read from `VITE_ALLOWED_MESSAGE_ORIGINS` (comma-separated).
 * Entries may use a leading `*` as a wildcard prefix — e.g.
 * `*-adminpanel.7shifts.dev` matches any origin whose hostname ends with
 * `-adminpanel.7shifts.dev`.
 */
export function isOriginAllowed(origin: string): boolean {
    const allowlist = env.allowedMessageOrigins;

    if (allowlist.length === 0) {
        if (env.isDev) return true;
        if (!warnedEmptyProdAllowlist) {
            warnedEmptyProdAllowlist = true;
            console.error(
                '[postMessage] VITE_ALLOWED_MESSAGE_ORIGINS is empty in ' +
                    'production. All inbound postMessage events will be ' +
                    'rejected, breaking session resumption and theme/companyId ' +
                    'init. Configure the allowlist for the host(s) embedding ' +
                    'this terminal.'
            );
        }
        return false;
    }

    return allowlist.some(entry => matchesAllowlistEntry(entry, origin));
}

function matchesAllowlistEntry(entry: string, origin: string): boolean {
    if (!entry.includes('*')) return entry === origin;
    // Wildcard entries: a leading `*` matches any prefix of the origin string.
    // e.g. `*-adminpanel.7shifts.dev` matches `https://branch-adminpanel.7shifts.dev`
    const suffix = entry.slice(1);
    return origin.endsWith(suffix);
}
